import { motion } from "framer-motion";

export function initials(name = "") {
  return name.split(" ").filter(Boolean).map(w => w[0]).join("").toUpperCase().slice(0, 2) || "?";
}

export function avatarColor(name = "") {
  const colors = ["#0071e3", "#34aadc", "#5856d6", "#ff2d55", "#ff9500", "#4cd964", "#007aff"];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return colors[Math.abs(h) % colors.length];
}

export function timeAgo(ts) {
  if (!ts) return "Just now";
  const diff = (Date.now() - new Date(ts)) / 1000;
  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 172800) return "Yesterday";
  return `${Math.floor(diff / 86400)}d ago`;
}

export function Overline({ children, icon: Icon }) {
  return (
    <span className="inline-flex items-center gap-2 text-[13px] font-semibold tracking-[0.08em] uppercase text-[#6e6e73]">
      {Icon && <Icon className="w-4 h-4" />}{children}
    </span>
  );
}

export function EmptyState({ icon: Icon, message, testId }) {
  return (
    <div data-testid={testId} className="flex flex-col items-center justify-center py-20 text-center text-[#6e6e73] gap-4">
      {Icon && <Icon className="w-12 h-12 opacity-25" />}
      <p className="text-[15px] max-w-xs leading-relaxed">{message}</p>
    </div>
  );
}

export function SectionShell({ id, overline, title, subtitle, action, children, alt }) {
  return (
    <section id={id} className={`py-20 sm:py-24 ${alt ? "bg-[#f5f5f7]" : "bg-white"} border-t border-[#d2d2d7]`}>
      <div className="max-w-[980px] mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] }}
          className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10"
        >
          <div>
            {overline && <Overline>{overline}</Overline>}
            <h2
              className="mt-2 text-[40px] sm:text-[48px] font-bold text-[#1d1d1f]"
              style={{ letterSpacing: "-0.03em", lineHeight: "1.06" }}
            >
              {title}
            </h2>
            {subtitle && (
              <p className="mt-3 text-[16px] text-[#6e6e73] max-w-2xl leading-[1.55]">
                {subtitle}
              </p>
            )}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </motion.div>
        {children}
      </div>
    </section>
  );
}
